<template>
	<div class="time-view d-flex flex-align-center">
		<div
			v-if="acceptForHere"
			class="pick-up-time for-here"
			@click="showSchedule('Dine In')"
		>
			<!--			Removed due to requirements-->
			<!--			<div-->
			<!--				v-if="acceptForHere"-->
			<!--				class="pick-up-time for-here"-->
			<!--				:class="{ 'accept-both': acceptForHere && acceptToGo }"-->
			<!--				@click="showSchedule('For Here')"-->
			<!--			>-->
			<div class="pick-up-time-status">
				<icon-svg
					class="pick-up-time-status-icon"
					:icon="forHereStatus.icon"
					:height="16"
					:width="16"
					color="none"
				/>
			</div>
			<div class="pick-up-time-value">
				<div class="pick-up-time-value-name">
					Dine In
				</div>
				<div class="pick-up-time-value-separator" />
				<div class="pick-up-time-value-date">
					{{ forHereStatus.time }}
				</div>
			</div>
		</div>
		<!--		Removed due to requirements-->
		<!--		<div-->
		<!--			v-if="acceptForHere && acceptToGo"-->
		<!--			class="pick-up-time-vertical-separator"-->
		<!--		>-->
		<!--			<div />-->
		<!--		</div>-->
		<!--		<div-->
		<!--			v-if="acceptToGo"-->
		<!--			class="pick-up-time to-go"-->
		<!--			:class="{ 'accept-both': acceptForHere && acceptToGo }"-->
		<!--			@click="showSchedule('To Go')"-->
		<!--		>-->
		<!--			<div class="pick-up-time-status">-->
		<!--				<icon-svg-->
		<!--					class="pick-up-time-status-icon"-->
		<!--					:icon="toGoStatus.icon"-->
		<!--					:height="16"-->
		<!--					:width="16"-->
		<!--					color="none"-->
		<!--				/>-->
		<!--			</div>-->
		<!--			<div class="pick-up-time-value">-->
		<!--				<div class="pick-up-time-value-name">-->
		<!--					To Go-->
		<!--				</div>-->
		<!--				<div class="pick-up-time-value-separator" />-->
		<!--				<div class="pick-up-time-value-date">-->
		<!--					{{ toGoStatus.time }}-->
		<!--				</div>-->
		<!--			</div>-->
		<!--		</div>-->
	</div>
</template>

<script>
import availabilityTime from '@/mixins/availabilityTime'
import { getAmPmTime } from '@/utils/helpers'
import { mapState } from 'vuex'

export default {
	name: 'InVenueTime',

	mixins: [availabilityTime],

	computed: {
		...mapState('venue', [
			'isForHereNotAvailableNowAndAvailableToday',
			'isToGoNotAvailableNowAndAvailableToday'
		]),

		isToGoExist() {
			return this.toGoHours && this.toGoHours.length
		},

		isForHereExist() {
			return this.forHereHours && this.forHereHours.length
		},

		startForHere() {
			return this.isForHereExist && this.forHereHours[0].startTime
		},

		endForHere() {
			return this.isForHereExist && this.forHereHours[0].endTime
		},

		forHereStatus() {
			const endTime =
				getAmPmTime(this.endForHere, 'h:mm a')?.toUpperCase() || ''
			const startTime =
				getAmPmTime(this.startForHere, 'h:mm a')?.toUpperCase() || ''

			if (this.isForHereOrderingAvailable) {
				return {
					icon: 'ic_available',
					time: `ends at ${endTime}`
				}
			}

			if (
				!this.isForHereOrderingAvailable &&
				this.isForHereNotAvailableNowAndAvailableToday
			) {
				return {
					icon: 'ic_available_next',
					time: `starts at ${startTime}`
				}
			}

			if (
				!this.isForHereOrderingAvailable &&
				!this.isForHereNotAvailableNowAndAvailableToday &&
				this.isForHereExist
			) {
				return {
					icon: 'ic_unavailable',
					time: `starts on ${this.getDayName(
						this.forHereHours[0].dow
					)} ${startTime}`
				}
			}

			return {
				icon: 'ic_unavailable',
				time: 'Unavailable'
			}
		},

		startToGo() {
			return this.isToGoExist && this.toGoHours[0].startTime
		},

		endToGo() {
			return this.isToGoExist && this.toGoHours[0].endTime
		},

		toGoStatus() {
			const endTime = getAmPmTime(this.endToGo, 'h:mm a')?.toUpperCase() || ''
			const startTime =
				getAmPmTime(this.startToGo, 'h:mm a')?.toUpperCase() || ''

			if (this.isToGoOrderingAvailable) {
				return {
					class: 'available',
					color: '#4AC692',
					icon: 'ic_available',
					time: `ends at ${endTime}`
				}
			}

			if (
				!this.isToGoOrderingAvailable &&
				this.isToGoNotAvailableNowAndAvailableToday
			) {
				return {
					class: 'next',
					color: '#E6B223',
					icon: 'ic_available_next',
					time: `starts at ${startTime}`
				}
			}

			if (
				!this.isToGoOrderingAvailable &&
				!this.isToGoNotAvailableNowAndAvailableToday &&
				this.isToGoExist
			) {
				return {
					class: 'unavailable',
					color: '#E9576A',
					icon: 'ic_unavailable',
					time: `starts on ${this.getDayName(
						this.toGoHours[0].dow
					)} ${startTime}`
				}
			}

			return {
				class: 'unavailable',
				color: '#E9576A',
				icon: 'ic_unavailable',
				time: 'Unavailable'
			}
		}
	}
}
</script>
